import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import { Info } from 'react-bytesize-icons';
import cmvretinitis from "../../../../assets/images/docs/debugtools/cmvretinitis.jpg";
import placeholdifier from "../../../../assets/images/docs/debugtools/placeholdifier.png";
import trackfocus from "../../../../assets/images/docs/debugtools/track-focus.mp4";
import threedview from "../../../../assets/images/docs/debugtools/3dview.mp4";
import placeholdifiertranslate from "../../../../assets/images/docs/debugtools/placeholdifier-translate.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  Info,
  cmvretinitis,
  placeholdifier,
  trackfocus,
  threedview,
  placeholdifiertranslate,
  React
};